import type { ConnectionStatus } from '../api';

/**
 * The one place connection status becomes colour and words — plan §3.1.
 *
 * Defined once so the list and the detail page can never disagree, and every
 * badge carries text as well as colour: --jungle and --papaya are not
 * distinguishable to everyone.
 */
const MAP: Record<ConnectionStatus | 'none', { label: string; cls: string; hint: string }> = {
  connected:    { label: 'Connected',    cls: 'badge-connected', hint: 'Healthy' },
  pending:      { label: 'Needs confirming', cls: 'badge-pending', hint: 'Company name does not match this client' },
  needs_reauth: { label: 'Reconnect needed', cls: 'badge-attention', hint: 'This client’s books are not readable until reconnected' },
  error:        { label: 'Failing',      cls: 'badge-attention', hint: 'Repeated failures talking to QuickBooks' },
  revoked:      { label: 'Disconnected', cls: 'badge-inactive', hint: 'No active connection' },
  none:         { label: 'Not connected', cls: 'badge-inactive', hint: 'QuickBooks has never been connected' },
};

export function StatusBadge({ status }: { status: ConnectionStatus | null }) {
  const s = MAP[status ?? 'none'];
  return (
    <span className={`badge ${s.cls}`} title={s.hint}>
      <span className="dot" aria-hidden="true" />
      {s.label}
    </span>
  );
}

export function statusHint(status: ConnectionStatus | null): string {
  return MAP[status ?? 'none'].hint;
}
